import React, { useEffect, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import groupEditIcon from "../../../../../assets/icons/configurationIcons/group-edit.svg";
import selectDeleteIcon from '../../../../../assets/icons/configurationIcons/trash-box.svg'
import EditIcon from '../../../../../assets/icons/headerIcons/edit-icon.svg';
import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "../../../../../recoil-store/recoil-state";



const options = {
    Edit: <img alt="Edit Icon" src={EditIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
    Delete: <img alt="Delete Icon" src={selectDeleteIcon} style={{ fontSize: "18px", marginRight: "5px" }} />,
};

function AutomGroupOptions(props) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const setAlert = useSetRecoilState(alertState);

    const menu = async (option, e) => {
        if (option === "Edit") {
            e.stopPropagation();
            props.options.edit();
        } else if (option === "Delete") {
            props.options.delete();
        }
        handleClose()
    };

    const handleClick = (e) => {
        if (!e) e = window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <img style={{ zIndex: 9999 }} className='group-edit-icon' src={groupEditIcon} onClick={handleClick} />
            <Menu
                style={{ zIndex: 99999999 }}
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                }}
            >
                {Object.keys(options).map((option) => {
                    return <MenuItem
                        key={option}
                        style={{ color: "#212F3B", fontSize: "10px", fontWeight: 600 }}
                        onClick={(e) => menu(option, e)}
                    >
                        {options[option]}
                        {option}
                    </MenuItem>
                }
                )}
            </Menu>
        </>
    );
}

export default AutomGroupOptions;
